import { Plus, Trash2 } from 'lucide-react';
import { uid } from '../lib/model';
import { BLD_METHODS } from '../lib/sewerInsp';

// in-house leak: floor / room, detection methods and moisture readings
export default function BldProto({ t, obj, patch }) {
  const b = obj.bld || { floor: '', room: '', methods: [], items: [], note: '' };
  const set = (p) => patch({ bld: { ...b, ...p } });
  const upd = (id, p) => set({ items: b.items.map((x) => (x.id === id ? { ...x, ...p } : x)) });
  const tog = (m) => set({ methods: b.methods.includes(m) ? b.methods.filter((x) => x !== m) : [...b.methods, m] });
  return (
    <div className="si-box" data-testid="bld-proto-box">
      <div className="si-head"><b>🏠 {t.bpTitle}</b></div>
      <div className="row">
        <input data-testid="bld-floor-input" placeholder={t.bpFloor} value={b.floor} onChange={(e) => set({ floor: e.target.value })} />
        <input data-testid="bld-room-input" placeholder={t.bpRoom} value={b.room} onChange={(e) => set({ room: e.target.value })} />
      </div>
      <div className="chip-group">
        {BLD_METHODS.map((m) => <button key={m} type="button" className={`chip ${b.methods.includes(m) ? 'on' : ''}`} data-testid={`bld-method-${m}`} aria-pressed={b.methods.includes(m)} onClick={() => tog(m)}>{t['bpM_' + m]}</button>)}
      </div>
      <small className="muted">{t.bpReadings}</small>
      {b.items.map((x, i) => (
        <div className="si-row bp-row" key={x.id} data-testid={`bld-reading-${i}`}>
          <input data-testid={`bld-reading-place-${i}`} placeholder={t.bpPlace} value={x.place} onChange={(e) => upd(x.id, { place: e.target.value })} />
          <input inputMode="decimal" data-testid={`bld-reading-val-${i}`} placeholder={t.bpVal} value={x.val} onChange={(e) => upd(x.id, { val: e.target.value })} />
          <select data-testid={`bld-reading-unit-${i}`} value={x.unit} onChange={(e) => upd(x.id, { unit: e.target.value })}><option value="pct">%</option><option value="dig">{t.bpDigits}</option></select>
          <button type="button" className="icon-btn danger" data-testid={`bld-reading-del-${i}`} onClick={() => set({ items: b.items.filter((y) => y.id !== x.id) })}><Trash2 size={14} /></button>
        </div>
      ))}
      <button type="button" className="btn btn-outline btn-sm" data-testid="bld-reading-add-btn" onClick={() => set({ items: [...b.items, { id: uid('mr'), place: '', val: '', unit: 'pct' }] })}><Plus size={14} /> {t.bpAdd}</button>
      <input data-testid="bld-note-input" placeholder={t.fitNote} value={b.note} onChange={(e) => set({ note: e.target.value })} />
    </div>
  );
}
